import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const LeadsPanel = () => {
  const [leads, setLeads] = useState({ leads: [], stats: {} });
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await axios.get(`${API}/api/admin/leads`, { withCredentials: true });
      if (r.data) setLeads(r.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  if (loading) return <p className="text-white/40">Cargando leads...</p>;

  const allLeads = leads.leads || [];
  const stats = leads.stats || {};
  const filtered = allLeads.filter(l => {
    if (filter === 'verified') return l.verified && !l.converted;
    if (filter === 'unverified') return !l.verified;
    if (filter === 'converted') return l.converted;
    return true;
  });

  return (
    <div data-testid="leads-panel">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">Leads y Prospectos</h2>
        <button onClick={load} className="p-2 hover:bg-white/10 rounded-lg text-white/40"><RefreshCw className="w-4 h-4" /></button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="glass-card p-4" data-testid="leads-stat-total">
          <p className="text-2xl font-bold">{stats.total || 0}</p>
          <p className="text-xs text-white/50">Total Leads</p>
        </div>
        <div className="glass-card p-4" data-testid="leads-stat-verified">
          <p className="text-2xl font-bold text-green-400">{stats.verified || 0}</p>
          <p className="text-xs text-white/50">Verificados</p>
        </div>
        <div className="glass-card p-4" data-testid="leads-stat-unverified">
          <p className="text-2xl font-bold text-yellow-400">{stats.unverified || 0}</p>
          <p className="text-xs text-white/50">No Verificados</p>
        </div>
        <div className="glass-card p-4" data-testid="leads-stat-converted">
          <p className="text-2xl font-bold text-[#E8720C]">{stats.converted || 0}</p>
          <p className="text-xs text-white/50">Convertidos ({stats.conversion_rate || 0}%)</p>
        </div>
      </div>

      <div className="flex gap-2 mb-4">
        {['all', 'verified', 'unverified', 'converted'].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            className={`px-4 py-2 rounded-lg text-xs font-medium transition-all ${filter === f ? 'bg-[#E8720C] text-white' : 'bg-white/5 text-white/50 hover:bg-white/10'}`}
            data-testid={`leads-filter-${f}`}>
            {f === 'all' ? 'Todos' : f === 'verified' ? 'Verificados' : f === 'unverified' ? 'No Verificados' : 'Convertidos'} ({f === 'all' ? allLeads.length : filtered.length})
          </button>
        ))}
      </div>

      <div className="glass-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="leads-table">
            <thead><tr className="border-b border-white/10 text-white/40 text-xs">
              <th className="text-left p-4">Nombre</th><th className="text-left p-4">Email</th>
              <th className="text-left p-4">Pais</th><th className="text-center p-4">Verificado</th>
              <th className="text-center p-4">Convertido</th><th className="text-left p-4">Creado</th>
              <th className="text-left p-4">Ultimo Email</th>
            </tr></thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={7} className="p-8 text-center text-white/30">Sin leads</td></tr>
              ) : filtered.map((l, i) => (
                <tr key={i} className="border-b border-white/5 hover:bg-white/5" data-testid={`lead-row-${i}`}>
                  <td className="p-4 font-medium">{l.name || 'N/A'}</td>
                  <td className="p-4 text-white/60 font-mono text-xs">{l.email}</td>
                  <td className="p-4 text-white/60">{l.country || 'Desconocido'}</td>
                  <td className="p-4 text-center">
                    {l.verified ? (
                      <span className="px-2 py-1 rounded-full text-[10px] font-medium bg-green-500/15 text-green-400 border border-green-500/20">Si</span>
                    ) : (
                      <span className="px-2 py-1 rounded-full text-[10px] font-medium bg-yellow-500/15 text-yellow-400 border border-yellow-500/20">No</span>
                    )}
                  </td>
                  <td className="p-4 text-center">
                    {l.converted ? (
                      <span className="px-2 py-1 rounded-full text-[10px] font-medium bg-[#E8720C]/15 text-[#E8720C] border border-[#E8720C]/20">Usuario</span>
                    ) : (
                      <span className="px-2 py-1 rounded-full text-[10px] font-medium bg-white/5 text-white/30 border border-white/10">Lead</span>
                    )}
                  </td>
                  <td className="p-4 text-white/40 text-xs">{l.created_at ? new Date(l.created_at).toLocaleDateString() : 'N/A'}</td>
                  <td className="p-4 text-white/40 text-xs">{l.last_verification_sent ? new Date(l.last_verification_sent).toLocaleDateString() : 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeadsPanel;
